import React, { useState } from 'react';
import { Button, Input } from '@spark';

/**
 * "New field name" input + Add button with the "Saved with the prompt, not
 * the dataset." hint — shown as the text-selection popover body and as the
 * footer of the insert-fields menu.
 */
const NewFieldForm = ({ onAdd, autoFocus = true, addDisabled = false }) => {
    const [name, setName] = useState('');

    const submit = () => {
        const trimmed = name.trim();
        if (!trimmed || addDisabled) return;
        onAdd(trimmed);
        setName('');
    };

    return (
        <div className="cw-pm-new-field">
            <div className="cw-pm-new-field__row">
                <Input
                    size="small"
                    showLabel={false}
                    showHelperText={false}
                    placeholder="New field name"
                    aria-label="New field name"
                    value={name}
                    autoFocus={autoFocus}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            submit();
                        }
                    }}
                />
                <Button
                    size="small"
                    variant="primary"
                    disabled={!name.trim() || addDisabled}
                    onClick={submit}
                >
                    Add
                </Button>
            </div>
            <p className="cw-pm-new-field__hint">Saved with the prompt, not the dataset.</p>
        </div>
    );
};

export default NewFieldForm;
